import React from 'react';

import { produce } from 'immer';
import { FormattedMessage } from 'react-intl';
import { call, put, select } from 'redux-saga/effects';

import { createMapping } from '@api/mapping';
import { conversionToolMergeSelectionModel } from '@models/ConversionTool/conversionToolMergeSelection';
import { history, vfileRoutes } from '@routes';
import { conversionToolColumnsResetAction } from '@store/conversionTool/conversionToolColumns/conversionToolColumns.actions';
import {
  createMappingFailureAction,
  createMappingSuccessAction,
} from '@store/conversionTool/createMapping/createMapping.actions';
import { toastError } from '@store/notifications';
import { selectedValuesSelector } from '@store/selectors/conversionTool/selectedValues';
import { selectedFilingPeriodSelector } from '@store/selectors/savedFilingPeriod';

export const createMappingSaga = function* ({ payload = {} }) {
  try {
    const selectedFiling = yield select(selectedFilingPeriodSelector);
    const selectedValues = yield select(selectedValuesSelector);

    const mergedValues = yield call(
      conversionToolMergeSelectionModel,
      selectedValues,
      payload.data.columnMap
    );
    const newMapping = yield call(produce, payload.data, draft => {
      draft.columnMap = mergedValues;
      draft.entityJurisdiction = selectedFiling.entityJurisdiction;
      draft.filingType = selectedFiling.filingType;
    });

    const response = yield call(createMapping, newMapping);

    yield put(createMappingSuccessAction(response));
    yield put(conversionToolColumnsResetAction());

    yield call(history.push, {
      pathname: vfileRoutes.FILING_UPLOAD.make(selectedFiling.id),
      state: {
        openConversionTool: true,
        uploadedFile: payload.uploadedFile,
        mappingId: response.id,
        hideConversionHelp: true,
      },
    });
  } catch (error) {
    const { nonFieldErrors } = error.data || {};

    yield put([
      toastError({
        message: nonFieldErrors || (
          <FormattedMessage
            defaultMessage="An unexpected error occurred, please try again."
            id="global.notification.api-error-default"
          />
        ),
      }),
      createMappingFailureAction(error),
    ]);
  }
};
